<template>
    <div class="section-box report-post">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;line-height: 36px;">
                <el-button size="mini" :class="form.DataListType ==0 ?'selected':''" @click="chose(0)">待处理</el-button>
                <el-button size="mini" style="margin-left: 25px;" :class="form.DataListType ==1 ?'selected':''" @click="chose(1)">已删除</el-button>
                <el-button size="mini" style="margin-left: 25px;" :class="form.DataListType ==2 ?'selected':''" @click="chose(2)">未删除</el-button>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="举报内容" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.TagetContent" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.TagetContent || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="内容类别" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select 
                            size="mini" 
                            placeholder="请选择" 
                            v-model="form.ContentType" 
                            style="width: 100%" 
                            filterable
                        >
                            <el-option :value="1" label="帖子"></el-option>
                            <el-option :value="2" label="回复"></el-option>
                    </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.ContentTypeName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发帖人Code">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.PosterUserCode" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.PosterUserCode || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发帖时间" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-date-picker 
                            size="mini" 
                            v-model="form.PublishCreateTime" 
                            type="daterange" 
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" 
                            range-separator="—" 
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" 
                            style="width: 100%">
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.PostCreateTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="举报时间">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-date-picker 
                            size="mini" 
                            v-model="form.ComplaintCreateTime" 
                            type="daterange" 
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" 
                            range-separator="—" 
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" 
                            style="width: 100%">
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.PostComplaintCreateTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="举报选项">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select 
                            size="mini" 
                            placeholder="请选择" 
                            v-model="form.ComplaintReasonId" 
                            style="width: 100%" 
                            filterable
                        >
                            <el-option 
                                v-for="(item, index) in ComplaintReasonArr" 
                                :value="item.Id" 
                                :label="item.Reason" 
                                :key="index"
                            ></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.ComplaintReason || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="举报内容">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.ComplaintContent" placeholder="输入关键字搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.ComplaintContent || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="详情" width="230">
                <template slot-scope="scope">
                    <el-button size="mini" @click="checkPostDetail(scope.row.PostId)">详情</el-button>
                    <el-button size="mini" v-if="form.DataListType ==0" type="danger" @click="checkReport(scope.row.Id,1)">删除</el-button>
                    <el-button size="mini" v-if="form.DataListType ==0" type="info" @click="checkReport(scope.row.Id,2)">不删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageIndex"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { 
  getStorageToken,
} from '@/utils/store'
import {
    ListPostComplaint,       //获取举报列表
    GetOperationReason,     //获取删除原因
    DealPostComplaint,      //处理举报
} from "@/service/run";
  export default {
    data() {
        return {
            listLoading: false,
            form: {
                PageIndex: 1,
                PageSize: 10,

                TagetContent: '',       //举报内容标题
                ContentType: '',        //内容类别
                PosterUserCode: '',     //发帖人Code
                PublishCreateTime: [],  //创建时间
                ComplaintCreateTime: [],//举报时间
                ComplaintReasonId: '',  //举报选项
                ComplaintContent: '',   //举报内容
                DataListType: 0,        //数据列表类型 -1全部 0待处理，1已删除，2未删除
            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数
            tableData:[],
            ComplaintReasonArr: [],               //帖子分类
        }
    },
    activated(){},
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
        this.handleSearch()
        this.getOperationReason();
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        // 获取投诉选项
        getOperationReason(){
            GetOperationReason({
                type: 6
            }).then(res=> {
                this.ComplaintReasonArr = res.Data
            })
        },
        // table切换 
        chose(type){
            this.form.DataListType = type;
            this.handleSearch()
        },
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageIndex = val
            this.searchData.PageIndex = val
            this.GetListPublishedPost()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageIndex = 1
            this.form.PageSize = val
            this.searchData.PageIndex = 1
            this.searchData.PageSize = val
            this.GetListPublishedPost()
        },
        async GetListPublishedPost(){
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.TagetContent && delete data.TagetContent
            if(data.ContentType == ''){
                data.ContentType = -1
            }
            !data.PosterUserCode && delete data.PosterUserCode
            if (data.PublishCreateTime && data.PublishCreateTime.length) {
                data.PublishPostCreateStartTime = data.PublishCreateTime[0]
                data.PublishPostCreateEndTime = data.PublishCreateTime[1]
            }
            delete data.PublishCreateTime
            if (data.ComplaintCreateTime && data.ComplaintCreateTime.length) {
                data.ComplaintCreateStartTime = data.ComplaintCreateTime[0]
                data.ComplaintCreateEndTime = data.ComplaintCreateTime[1]
            }
            delete data.ComplaintCreateTime
            if(data.ComplaintReasonId == '') {
                delete data.ComplaintReasonId
            }
            !data.ComplaintContent && delete data.ComplaintContent
            let res = await ListPostComplaint(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.List
            this.total = res.Data.TotalRows
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
        // 点击跳转详情
        checkPostDetail(id) {
            this.$router.push(`/run/reportPostDetail?id=${id}`);
        },
        // 处理举报
        checkReport(id,is){
            let tips = '删除'
            if(is == 2) {
                tips = '不删除'
            }
            this.$confirm('是否'+ tips +'?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                DealPostComplaint({
                    PostComplaintId: id,
                    IsDelete: is==1?true:false
                }).then(res=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success(res.Message)
                    this.GetListPublishedPost()
                })
            }).catch(() => {});
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
    .report-post {
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>